module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Riniken_AG-0d42ccd7b3763eca0158ca4aca7c0a68.svg";